import 'react-toastify/dist/ReactToastify.css';
import '../styles/merchant_buds.css';
import React, { useState, useEffect, useRef } from 'react';
import BusinessService from '../services/business_services';
import LOYALBUDS_BLACK from "../media/images/loyalbuds.png";
import {
    FaTimes, FaQrcode, FaPrint, FaCheck, FaClipboard, FaCheckCircle,
    FaUsers, FaPowerOff, FaPlus, FaMapMarkerAlt, FaArrowLeft
} from "react-icons/fa";
import LOADER from "../media/images/loader.gif";
import { ToastContainer, toast } from 'react-toastify';
import { TOAST_OPTIONS } from '../constants';
import { useParams } from 'react-router';
import QRCode from 'react-qr-code';
import { toJpeg } from 'html-to-image';
import Header from './header';

function DistributionBuds() {
    const [merchant, setMerchant] = useState({});
    const [bud, setBud] = useState();
    const [distributions, setDistributions] = useState([]);
    const [expiredDistributions, setExpiredDistributions] = useState([]);
    const [selectedDistrib, setSelectDistrib] = useState(null);
    const [reactivatedDistrib, setReactivatedDistrib] = useState(null);
    const [copied, setCopied] = useState();
    const [processing, setProcessing] = useState(false);
    const [printing, setPrinting] = useState(false);
    const [expired, setExpired] = useState(false);
    const [advanced, setAdvanced] = useState(false);
    const [location, setLocation] = useState(false);
    const [visible, setVisible] = useState(true);
    const [xp, setXp] = useState(true);
    const [distance, setDistance] = useState(200);
    const [customAddress, setCustomAddress] = useState();
    const [endDate, setEndDate] = useState(null);
    const [create, setCreate] = useState(null);
    const [name, setName] = useState(null);
    const [quantity, setQuantity] = useState(0);
    const { id } = useParams();

    const printerQR = useRef();

    const loadMerchant = async () => {
        const data = await BusinessService.business();
        setMerchant({
            name: data.business.business_name,
            logo: data.business.logo || data.business.logo_url,
        });
    };

    const loadBuds = async () => {
        let data = await BusinessService.budsBusiness();
        for (let item of data) {
            if (id === item.bud_uuid) setBud(item);
        }
        data = await BusinessService.budDistributions(id);
        setDistributions(data);
        data = await BusinessService.budDistributions(id, true);
        setExpiredDistributions(data);
    };

    const copyLink = async (token) => {
        navigator.clipboard.writeText(`https://play.loyalbuds.app?bud_token=${token}`);
        setCopied(token);
        setTimeout(() => setCopied(null), 1000);
    };

    const distribute = async () => {
        if (quantity < 1) {
            toast.warning('Veuillez renseigner une quantité de min. 1 carte', TOAST_OPTIONS);
        } else if (!name || name.length < 3) {
            toast.warning('Veuillez renseigner un nom de plus de 3 caractères', TOAST_OPTIONS);
        } else if (!distance || distance < 50 || distance > 500) {
            toast.warning('La distance de géolocalisation doit être entre 50 et 500 mètres', TOAST_OPTIONS);
        } else {
            try {
                setProcessing(true);
                const status = await BusinessService.setBudDistribution(
                    bud.bud_uuid, parseInt(quantity), name,
                    endDate ? new Date(endDate).toISOString() : null, location,
                    parseInt(distance), customAddress, visible, xp
                );
                setProcessing(false);
                if (status) {
                    toast.success("Distribution référencée.", TOAST_OPTIONS);
                    setCreate(null);
                    loadBuds();
                } else {
                    toast.error("La mise en place de la distribution a échoué", TOAST_OPTIONS);
                }
            } catch (e) {
                setProcessing(false);
                toast.error(e.response?.data ? e.response.data.message : e.message, TOAST_OPTIONS);
            }
        }
    };

    const stop = async (distribution_uuid) => {
        if (window.confirm("Êtes-vous sûr de supprimer et arrêter cette distribution ?")) {
            setProcessing(true);
            const status = await BusinessService.stopBudDistribution(bud.bud_uuid, distribution_uuid);
            setProcessing(false);
            if (status) {
                toast.success("Distribution supprimée.", TOAST_OPTIONS);
                loadBuds();
            } else
                toast.error("La suppression de la distribution a échoué", TOAST_OPTIONS);
        }
    };

    const reactivate = async (d) => {
        if (window.confirm("Êtes-vous sûr de réactiver cette distribution ?")) {
            setProcessing(true);
            const status = await BusinessService.reactivateBudDistribution(
                d.distribution_name,
                d.expiration_date ? new Date(d.expiration_date).toISOString() : null,
                d.distribution_uuid, parseInt(d.nb_card), d.strict_location,
                parseInt(d.distance || distance), d.distribution_address, d.on_map, d.distribute_xp
            );
            setProcessing(false);
            if (status) {
                setCreate(null);
                toast.success("Distribution réactivée.", TOAST_OPTIONS);
                loadBuds();
            } else
                toast.error("La réactivation de la distribution a échoué", TOAST_OPTIONS);
        }
    };

    const htmlToImageConvert = async () => {
        await setPrinting(true);
        toJpeg(printerQR.current, { quality: 1, style: { background: "white" } })
            .then((dataUrl) => {
                const link = document.createElement("a");
                link.download = `${bud.bud_info.bud_name}_loyalbuds_qr.png`;
                link.href = dataUrl;
                link.click();
                setTimeout(() => setPrinting(false), 1000);
            })
            .catch(() => setPrinting(false));
    };

    useEffect(() => {
        loadMerchant();
        loadBuds();
        // eslint-disable-next-line
    }, []);

    const formatEndDate = (d) => d
        ? `${new Date(d).toLocaleDateString()} ${new Date(d).toLocaleTimeString().substring(0, 5)}`
        : "aucune";

    const renderDistribRow = (distrib, isExpired = false) => (
        <div className="mb-distrib" key={distrib.distribution_uuid}>
            {!isExpired && (
                <div className="mb-distrib-qr" onClick={() => setSelectDistrib(distrib)} title="Voir QR code">
                    <FaQrcode />
                    <span className="mb-distrib-qr-label">QR</span>
                </div>
            )}
            <div className="mb-distrib-info">
                <div className="name">{distrib.distribution_name || 'Sans nom'}</div>
                <div className="meta">
                    {distrib.strict_location && <FaMapMarkerAlt style={{ marginRight: 4 }} />}
                    <strong>{distrib.nb_distributed}</strong> / {distrib.nb_card} distribués
                    {' • '}Fin : {formatEndDate(distrib.expiration_date)}
                    {distrib.distribution_address && <> {' • '}{distrib.distribution_address}</>}
                </div>
            </div>
            <div className="mb-distrib-actions">
                {!isExpired && (
                    <div className="mb-distrib-action" onClick={() => copyLink(distrib.distribution_token)} title="Copier le lien">
                        {copied === distrib.distribution_token ? <FaCheckCircle /> : <FaClipboard />}
                        <span className="mb-distrib-action-label">
                            {copied === distrib.distribution_token ? 'Copié' : 'Copier'}
                        </span>
                    </div>
                )}
                <a className="mb-distrib-action"
                    href={`/merchants/distribution/details/${distrib.distribution_name || "Unamed distribution"}/${bud.bud_uuid}/${distrib.distribution_token}`}
                    target="_blank" rel="noreferrer" title="Voir les utilisateurs">
                    <FaUsers />
                    <span className="mb-distrib-action-label">Clients</span>
                </a>
                {!isExpired && (
                    <div className="mb-distrib-action danger" onClick={() => stop(distrib.distribution_uuid)} title="Arrêter">
                        <FaTimes />
                        <span className="mb-distrib-action-label">Arrêter</span>
                    </div>
                )}
                {isExpired && (
                    <div className="mb-distrib-action" onClick={() => { setReactivatedDistrib({ ...distrib, expiration_date: null }); setCreate("reactivate"); }} title="Réactiver">
                        <FaPowerOff />
                        <span className="mb-distrib-action-label">Réactiver</span>
                    </div>
                )}
            </div>
        </div>
    );

    return (
        <div className="container">
            <Header page={"Buds"} />

            <div className="content simple" style={{ paddingTop: 40 }}>
                <div className="mb-page">
                    <div className="mb-intro">
                        <h1>Distributions</h1>
                        {bud && <p>Gérez la distribution de <strong style={{ color: "#FFF" }}>{bud.bud_info.bud_name}</strong>.</p>}
                    </div>

                    {bud && (
                        <div className="mb-bud-header">
                            <div className="mb-bud-thumb"
                                style={{ backgroundImage: `url('${bud.bud_info.img_url}')` }} />
                            <div className="mb-bud-meta">
                                <h2>{bud.bud_info.bud_name}</h2>
                                <span className={`mb-rarity-badge ${bud.bud_info.bud_level}`}>
                                    {bud.bud_info.bud_level.toUpperCase()}
                                </span>
                            </div>
                        </div>
                    )}

                    <div className="mb-tabs">
                        <div className={`mb-tab ${!expired ? 'active' : ''}`} onClick={() => setExpired(false)}>
                            Distributions actives ({distributions.length})
                        </div>
                        <div className={`mb-tab ${expired ? 'active' : ''}`} onClick={() => setExpired(true)}>
                            Expirées ({expiredDistributions.length})
                        </div>
                    </div>

                    <div className="mb-distrib-list">
                        {!expired && distributions.length === 0 && (
                            <div className="mb-empty"><p>Aucune distribution active.</p></div>
                        )}
                        {expired && expiredDistributions.length === 0 && (
                            <div className="mb-empty"><p>Aucune distribution expirée.</p></div>
                        )}
                        {!expired && distributions.map(d => renderDistribRow(d, false))}
                        {expired && expiredDistributions.map(d => renderDistribRow(d, true))}
                    </div>

                    {create === "new" && bud && (
                        <div className="mb-form">
                            <h3>Nouvelle distribution</h3>

                            <label>Nom de la distribution</label>
                            <input type="text" placeholder="Ex: Campagne d'été" onChange={(e) => setName(e.target.value)} />

                            <label>Quantité de cartes</label>
                            <input type="number" placeholder="Quantité" onChange={(e) => setQuantity(e.target.value)} />

                            <label>Date de fin <span className="help">(optionnelle)</span></label>
                            <input type="datetime-local" onChange={(e) => setEndDate(e.target.value)} />

                            <div className="mb-check">
                                <input type="checkbox" onChange={() => setLocation(!location)} checked={location} />
                                <div className="txt">
                                    Restriction par géolocalisation
                                    <small>Seuls les joueurs présents à votre adresse pourront récupérer le Bud.</small>
                                </div>
                            </div>

                            <div className="mb-advanced-toggle" onClick={() => setAdvanced(!advanced)}>
                                {advanced ? '— Masquer' : '+ Afficher'} les paramètres avancés
                            </div>

                            {advanced && (
                                <>
                                    <div className="mb-check">
                                        <input type="checkbox" onChange={() => setVisible(!visible)} checked={visible} />
                                        <div className="txt">
                                            Visible sur la carte des joueurs
                                            <small>Votre Bud sera visible pour les joueurs à moins de {distance}m.</small>
                                        </div>
                                    </div>

                                    <label>Adresse de géolocalisation <span className="help">(optionnelle)</span></label>
                                    <input type="text" placeholder="Adresse complète" onChange={(e) => setCustomAddress(e.target.value)} />

                                    <label>Précision (50–500 mètres)</label>
                                    <input type="number" min={50} max={500} value={distance} onChange={(e) => setDistance(e.target.value)} />

                                    <div className="mb-check">
                                        <input type="checkbox" onChange={() => setXp(!xp)} checked={xp} />
                                        <div className="txt">
                                            Distribuer de l'XP
                                            <small>Si le joueur a déjà votre carte, il recevra +1 XP.</small>
                                        </div>
                                    </div>
                                </>
                            )}

                            {processing
                                ? <img src={LOADER} width="80" alt="Chargement" />
                                : (
                                    <div className="mb-actions">
                                        <div className="mb-btn primary" onClick={distribute}>
                                            <FaCheck /> Créer la distribution
                                        </div>
                                        <div className="mb-btn secondary" onClick={() => setCreate(null)}>
                                            <FaTimes /> Annuler
                                        </div>
                                    </div>
                                )}
                        </div>
                    )}

                    {create === "reactivate" && reactivatedDistrib && (
                        <div className="mb-form">
                            <h3>Réactiver la distribution</h3>

                            <label>Nom de la distribution</label>
                            <input type="text" defaultValue={reactivatedDistrib.distribution_name}
                                onChange={(e) => setReactivatedDistrib({ ...reactivatedDistrib, distribution_name: e.target.value })} />

                            <label>Quantité de cartes</label>
                            <input type="number" defaultValue={reactivatedDistrib.nb_card}
                                onChange={(e) => setReactivatedDistrib({ ...reactivatedDistrib, nb_card: e.target.value })} />

                            <label>Date de fin <span className="help">(optionnelle)</span></label>
                            <input type="datetime-local"
                                onChange={(e) => setReactivatedDistrib({ ...reactivatedDistrib, expiration_date: e.target.value })} />

                            <div className="mb-check">
                                <input type="checkbox" checked={reactivatedDistrib.strict_location}
                                    onChange={() => setReactivatedDistrib({ ...reactivatedDistrib, strict_location: !reactivatedDistrib.strict_location })} />
                                <div className="txt">
                                    Restriction par géolocalisation
                                    <small>Seuls les joueurs présents à votre adresse pourront récupérer le Bud.</small>
                                </div>
                            </div>

                            <div className="mb-advanced-toggle" onClick={() => setAdvanced(!advanced)}>
                                {advanced ? '— Masquer' : '+ Afficher'} les paramètres avancés
                            </div>

                            {advanced && (
                                <>
                                    <div className="mb-check">
                                        <input type="checkbox" checked={reactivatedDistrib.on_map}
                                            onChange={() => setReactivatedDistrib({ ...reactivatedDistrib, on_map: !reactivatedDistrib.on_map })} />
                                        <div className="txt">Visible sur la carte des joueurs</div>
                                    </div>

                                    <label>Adresse de géolocalisation</label>
                                    <input type="text" defaultValue={reactivatedDistrib.distribution_address}
                                        onChange={(e) => setReactivatedDistrib({ ...reactivatedDistrib, distribution_address: e.target.value })} />

                                    <label>Précision (50–500 mètres)</label>
                                    <input type="number" min={50} max={500}
                                        value={reactivatedDistrib.distance || distance}
                                        onChange={(e) => setReactivatedDistrib({ ...reactivatedDistrib, distance: e.target.value })} />

                                    <div className="mb-check">
                                        <input type="checkbox" checked={reactivatedDistrib.distribute_xp}
                                            onChange={() => setReactivatedDistrib({ ...reactivatedDistrib, distribute_xp: !reactivatedDistrib.distribute_xp })} />
                                        <div className="txt">Distribuer de l'XP</div>
                                    </div>
                                </>
                            )}

                            {processing
                                ? <img src={LOADER} width="80" alt="Chargement" />
                                : (
                                    <div className="mb-actions">
                                        <div className="mb-btn primary" onClick={() => reactivate(reactivatedDistrib)}>
                                            <FaCheck /> Réactiver
                                        </div>
                                        <div className="mb-btn secondary" onClick={() => setCreate(null)}>
                                            <FaTimes /> Annuler
                                        </div>
                                    </div>
                                )}
                        </div>
                    )}

                    {!create && (
                        <div className="mb-actions">
                            <div className="mb-btn primary" onClick={() => setCreate("new")}>
                                <FaPlus /> Nouvelle distribution
                            </div>
                            <div className="mb-btn secondary" onClick={() => window.location.href = "/merchants/buds"}>
                                <FaArrowLeft /> Retour aux Buds
                            </div>
                        </div>
                    )}
                </div>
            </div>

            {printing && (
                <div className="frame_runner">
                    <img src={LOADER} className="runner" alt="Chargement" />
                </div>
            )}

            {selectedDistrib && bud && (
                <div className="mb-qr-overlay" onClick={(e) => { if (e.target === e.currentTarget) setSelectDistrib(null); }}>
                    <div className="mb-qr-card" ref={printerQR}>
                        {!printing && (
                            <div className="mb-qr-actions no-print">
                                <div className="mb-qr-icon" onClick={htmlToImageConvert} title="Télécharger"><FaPrint /></div>
                                <div className="mb-qr-icon" onClick={() => setSelectDistrib(null)} title="Fermer"><FaTimes /></div>
                            </div>
                        )}
                        <img src={LOYALBUDS_BLACK} className="logo" alt="logo LoyalBuds" />
                        <div className="qr-box">
                            <QRCode size={200}
                                style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                                bgColor={'transparent'}
                                value={`https://play.loyalbuds.app?bud_token=${selectedDistrib.distribution_token}`}
                                viewBox={`0 0 200 200`} />
                        </div>
                        <p>Offert par <strong>{merchant.name}</strong></p>
                    </div>
                </div>
            )}

            <ToastContainer />
        </div>
    );
}

export default DistributionBuds;
